import { useQuery } from "react-query";
import { ApiClient } from "../utils/api";
import type { Account } from "./types";

type QueryParams = {
	building_name?: string;
};

export const useAccounts = (params?: QueryParams) => {
	return useQuery<Account[]>("accounts", async () => {
		const response = await ApiClient.get("/accounts", { params });

		return response.data;
	});
};
